import { gql, useSubscription } from '@apollo/client';
import {
  BedSensorCommandNode,
  BedSensorCommandUpdatesSubscription,
} from '../../__generated__/graphql';

const bedSensorCommandUpdatesSubscription = gql`
  subscription BedSensorCommandUpdates($filters: BedSensorCommandFilters!) {
    bedSensorCommandUpdates(filters: $filters) {
      _id
      crud
      new {
        _id
        bedSensorId
        timestampMs
        message
        ok
      }
    }
  }
`;

function useBedSensorCommandUpdates(
  filters: any,
  onUpdate: (bs: BedSensorCommandNode) => void,
) {
  useSubscription<BedSensorCommandUpdatesSubscription>(
    bedSensorCommandUpdatesSubscription,
    {
      skip: !filters,
      variables: {
        filters,
      },
      fetchPolicy: 'no-cache',
      onSubscriptionData: ({ client, subscriptionData: result }: any) => {
        try {
          const update = result?.data?.bedSensorCommandUpdates;
          if (update?.new) {
            switch (update.crud) {
              case 'insert':
                onUpdate(update.new as BedSensorCommandNode);
                break;
              default:
                break;
            }
          }
        } catch (err) {
          console.error(err);
        }
      },
    },
  );
}

export default useBedSensorCommandUpdates;
